export const DEFAULT_ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7378772993e302a4fbca0c1513f18fbb-1720005672691/jtbd_inbox.png';
